import { ConvertObjectToFormData, CheckRawFile, NormalizeRawFile, SetFormBodyReq } from './type'
import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import isBoolean from 'lodash/isBoolean'
import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'

export const isDateValid = (date): boolean => {
  const isDayjs = dayjs.isDayjs(date)
  const isValid = dayjs(dayjs(), 'YYYY-MM-DD', true).isValid()
  return (isDayjs && isValid) || (date instanceof Date && !isNaN(date.valueOf()))
}

export const isExpire = (expireAt): boolean => {
  const defaultDate = dayjs()
  const expireAtDayjsObject = dayjs(expireAt)
  return expireAt ? expireAtDayjsObject.isBefore(defaultDate) : false
}

const checkRawFile: CheckRawFile = (data) => {
  const result = { isMultipleInput: false, isRawFile: false }
  if (!data) return result

  // if a user upload the multiple file
  if (Array.isArray(data)) {
    result.isMultipleInput = true
    for (let index = 0; index < data.length; index++) {
      const { rawFile } = data[index]
      if (!rawFile) continue
      result.isRawFile = true
      return result
    }
  }

  // if a user upload the single file
  const { rawFile, path, size, original_name: originName } = data
  // if a user just the submit button and does not upload any file
  if (!rawFile && originName && path && size > 0) return result
  // if a user upload some file
  if (rawFile) {
    result.isRawFile = true
    return result
  }

  return result
}

const normalizeRawFile: NormalizeRawFile = (data, isMultiple = false) => {
  // convert object rawFile to File array
  if (isMultiple) {
    const files = []
    data.forEach((file) => {
      const { rawFile } = file
      if (rawFile) files.push(rawFile)
    })
    return files.length > 0 ? files : null
  } else {
    const { rawFile } = data
    return rawFile ? rawFile : null
  }
}

const convertObjectToFormData: ConvertObjectToFormData = (object, convertToJson = []) => {
  const newformData = new FormData()

  for (const key in object) {
    const field = object[key]
    // ignore empty field
    if (isEmpty(field) && !isBoolean(field) && !isNumber(field) && !isDateValid(field)) continue
    const { isMultipleInput, isRawFile } = checkRawFile(field)

    if (dayjs(field, 'YYYY-MM-DD', true).isValid()) {
      newformData.append(key, field.toISOString ? field.toISOString() : field)
      continue
    }

    if (isRawFile) {
      const files = normalizeRawFile(object[key], isMultipleInput)

      if (!files) continue

      // Appending the RawFile to formData
      if (!isMultipleInput) newformData.append(key, files)
      if (isMultipleInput) {
        files.forEach((file) => newformData.append(`${key}`, file))
      }
      continue
    }

    // If the field has key in convertToJson list. it get convert to json
    if (convertToJson.includes(key)) {
      newformData.append(`${key}`, JSON.stringify(field))
      continue
    }

    // Appending the select multiple value to formData
    if (Array.isArray(field)) {
      if (!isString(field[0])) continue

      field.forEach((id) => {
        if (id) newformData.append(`${key}`, id)
      })
      continue
    }

    // Appending Datetime value to formData
    if (isDateValid(field)) {
      newformData.append(key, field.toISOString ? field.toISOString() : field)
      continue
    }

    // ignore any object in the field's value which not defined in convertToJson list
    if (isObject(field)) continue
    // Appending the normal fields to formData
    newformData.append(key, field)
  }
  return newformData
}

export const setFormBodyReq: SetFormBodyReq = ({
  encType = 'application/json',
  convertToJson = [],
  ...data
}) => {
  return {
    encType,
    body: encType === 'application/json' ? data : convertObjectToFormData(data, convertToJson),
  }
}
